export enum NavigationActions {
  NAVIGATION_HIDE_LEFT_RAIL = 'NAVIGATION_HIDE_LEFT_RAIL',
  NAVIGATION_DOC_OUTSIDE_WORKSPACE = 'NAVIGATION_DOC_OUTSIDE_WORKSPACE',
  NAVIGATION_WORKSPACE_DROPDOWN_OPEN = 'NAVIGATION_WORKSPACE_DROPDOWN_OPEN',
  NAVIGATION_SET_PREFERRED_SORT = 'NAVIGATION_SET_PREFERRED_SORT',
}
